import { createApp } from 'vue';

import App from '@/App';
import router from '@/system_modules/router';
// import store from '@/system_modules/store';

import { createPinia } from 'pinia';

import titleMixin from '@/system_modules/utils/titleMixin';
// import { createHead } from "@vueuse/head";
// import { createHead } from '@unhead/vue/client';

import PrimeVue from 'primevue/config';
import Lara from '@primevue/themes/aura';

// import {G} from '@/_common';


const pinia = createPinia()

const ap = createApp(App)

// ap.use(store)
ap.use(pinia);
ap.use(router);
ap.use(PrimeVue, {
    // unstyled: true,
    theme: {
        preset: Lara,
        options: {
            prefix: 'p',
            // darkModeSelector: 'dark',
            darkModeSelector: false,
            cssLayer: true
        }
    },
    // semantic:{
    //     primary: {
    //         color: '#640000',
    //         background: '#640000',
    //     },
    //     colorScheme: {
    //         light: {
    //             primary: {
    //                 color: '#640000',
    //                 background: '#640000',
    //             }
    //         },
    //         // dark: {
    //         //     primary: {
    //         //         color: 'rgb(100,0,0)',
    //         //     },
    //         // },
    //     },
    // },
    // handle: {
    //     // borderRadius: '0px'
    // },
 });

// ap.use(createHead({
//     init: [
//       // change default initial lang
//       {
//         title: G.projectName,
//         description: G.projectInfo
//       },
//     ]
// }));

ap.mixin(titleMixin);


ap.config.globalProperties.$filters = {
    formatDate: value => {
        if( value ){
            let d = value.split('-');
            // let m = new Date(0,d[1],0).toLocaleDateString(store.state.lang, {month: 'short'});
            return `${d[2]}.${d[1]}.${d[0]}`;
        }
        else return value;
        // new Date(value).toLocaleDateString(store.state.lang, {
        //     year: 'numeric',
        //     month: 'short',
        //     day: 'numeric'
        // }),
    },

    replace: (str, txt1, txt2) => {
        if( str !== undefined ){
            let re = RegExp(txt1, "mgi");
            return str.replace(re, txt2);
        }
        else{
            return str;
        }
    },

    capitalize: str => str != '' ? (str.charAt(0).toUpperCase() + str.slice(1)) : '',

    stripTags: str => str != '' ? str.replace(/(<[^>]*>)*/gm, '') : '',

    formatCurrency: (value) => {
        if (value)
            return value.toLocaleString("az-AZ", {
                style: "currency",
                currency: "AZN",
            });
        return value;
    },

    encodeHTML: (str) => {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            "/": '&#x2F;'
        };
        return str.replace(/[&<>"'/]/g, s => map[s]);
    },

    encodeAttr(str) {
        return str.replace(/[^\w-]/g, s => {
            return `&#x${s.charCodeAt(0).toString(16)};`;
        });
    },

    encodeJS(str) {
        return str.replace(/[^\w-]/g, s => {
            let hex = s.charCodeAt(0).toString(16).padStart(2, '0');
            return `\\x${hex}`;
        });
    }
};


// ap.config.errorHandler = (err, instance, info) => {
//     return false;
//     // handle error, e.g. report to a service
// }

ap.mount('#app');
